const { debounce } = window.BAO.Utils

class ProductColoursSwatches extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['title', 'colour', 'label', 'label-text']
  }

  connectedCallback () {
    super.connectedCallback()

    const currentColour = this.els.colour.elements.find(
      colour => colour.getAttribute('aria-current') === 'true',
    )

    this.originalTitle = this.els.title.element.dataset.currentTitle || ''
    this.originalLabel = this.getLabelForColour(currentColour)
  }

  setupListeners () {
    this.onMouseOver = this.onMouseOver.bind(this)
    this.onMouseOut = this.onMouseOut.bind(this)
    this.restoreOriginalTitle = this.restoreOriginalTitle.bind(this)
    this.onMouseOutDebounced = debounce(this.restoreOriginalTitle, 300)

    this.els.colour.elements.forEach(colour => {
      this.listeners.add(colour, 'mouseover', this.onMouseOver)
      this.listeners.add(colour, 'mouseout', this.onMouseOut)
    })
  }

  onMouseOver (event) {
    if (this.onMouseOutDebounced?.cancel) {
      this.onMouseOutDebounced.cancel()
    }

    this.isHovering = true

    const colourElement = event.target.closest(this.els.colour.selector)
    if (!colourElement?.dataset?.title) return

    const labelElement = this.getLabelForColour(colourElement)
    if (!labelElement) return

    this.els.title.element.textContent = colourElement.dataset.title

    this.moveTitleToLabel(this.els.title.element, labelElement)
  }

  onMouseOut () {
    this.isHovering = false
    this.onMouseOutDebounced()
  }

  restoreOriginalTitle () {
    if (!this.originalTitle || this.isHovering) return

    this.els.title.element.textContent = this.originalTitle

    this.moveTitleToLabel(this.els.title.element, this.originalLabel)
  }

  getLabelForColour (colourElement) {
    if (!colourElement) return null

    const swatchGroup = colourElement.dataset?.swatchGroup
    if (!swatchGroup) return null

    let match = null

    this.els.label.elements.forEach(label => {
      if (label.dataset?.swatchGroup === swatchGroup) {
        match = label
      }
    })

    return match
  }

  moveTitleToLabel (titleElement, labelElement) {
    if (!titleElement || !labelElement) return

    if (!labelElement.contains(titleElement)) {
      labelElement.appendChild(titleElement)
    }

    this.updateLabelSeparators(titleElement)
  }

  updateLabelSeparators (titleElement) {
    this.els.label.elements.forEach(labelElement => {
      const labelTextElement = this.getLabelTextElement(labelElement)

      if (!labelTextElement) return

      const hasTitle = labelElement.contains(titleElement)

      labelTextElement.textContent = this.formatLabelText(
        labelTextElement.textContent,
        hasTitle,
      )
    })
  }

  getLabelTextElement (labelElement) {
    return labelElement.querySelector(
      '[data-product-colours-swatches-el="label-text"]',
    )
  }

  formatLabelText (textContent, hasTitle) {
    const baseText = textContent.replace(/:\s*$/, '').trimEnd()

    if (!hasTitle) return baseText

    return `${baseText}: `
  }
}

if (!customElements.get('product-colours-swatches')) {
  customElements.define('product-colours-swatches', ProductColoursSwatches)
}
